import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import InstructorProfileComp from './InstructorProfileComp'

function InstructorProfile() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <InstructorProfileComp />
      </div>
    </div>
  )
}

export default InstructorProfile
